import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WhatsappLogo, X } from "@phosphor-icons/react";

const NAMES = ["Aina", "Firdaus", "Nurul", "Hafiz", "Siti", "Amir", "Farah", "Zulkifli", "Iman", "Aiman", "Syafiq", "Liyana", "Danial", "Hidayah"];
const AREAS = ["Shah Alam", "Kajang", "Johor Bahru", "Ipoh", "Kuantan", "Kota Bharu", "Melaka", "Seremban", "Pulau Pinang", "Kuching", "Kota Kinabalu", "Ampang", "Nilai", "Cyberjaya"];
const MODELS = ["Sangkar AK3", "Sangkar AK6", "Sangkar AK7", "Sangkar AK9", "Catio Kustom"];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const makeSale = () => ({
    id: Date.now() + Math.random(),
    name: rand(NAMES),
    area: rand(AREAS),
    model: rand(MODELS),
    mins: Math.floor(Math.random() * 30) + 2,
});

export const SalesPopup = () => {
    const [sale, setSale] = useState(null);

    useEffect(() => {
        let hideTimer;
        const show = () => {
            setSale(makeSale());
            hideTimer = setTimeout(() => setSale(null), 4000);
        };
        const first = setTimeout(show, 3000);
        const interval = setInterval(show, 5000);
        return () => {
            clearTimeout(first);
            clearTimeout(hideTimer);
            clearInterval(interval);
        };
    }, []);

    return (
        <div className="fixed bottom-6 left-6 z-[110] max-w-[300px]">
            <AnimatePresence>
                {sale && (
                    <motion.div
                        key={sale.id}
                        data-testid="sales-popup"
                        initial={{ opacity: 0, y: 24, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 24, scale: 0.95 }}
                        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                        className="relative flex items-start gap-3 rounded-lg border border-border bg-surface/95 backdrop-blur-md p-4 pr-9 shadow-2xl"
                    >
                        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent">
                            <WhatsappLogo size={20} weight="fill" />
                        </span>
                        <div className="min-w-0">
                            <p className="text-sm text-ink leading-snug">
                                <span className="font-semibold">{sale.name}</span>
                                <span className="text-ink-soft"> dari {sale.area}</span>
                            </p>
                            <p className="text-sm text-ink-soft leading-snug">
                                baru menempah <span className="text-accent font-medium">{sale.model}</span>
                            </p>
                            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-ink-soft/70">
                                {sale.mins} minit lalu · Disahkan
                            </p>
                        </div>
                        <button
                            onClick={() => setSale(null)}
                            data-testid="sales-popup-close"
                            aria-label="Tutup"
                            className="absolute right-2.5 top-2.5 text-ink-soft hover:text-ink transition-colors"
                        >
                            <X size={16} />
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
